import {$themeConfig} from '@themeConfig';

export default {
    namespaced: true,
    state: {
        layout: {
            isRTL: $themeConfig.layout.isRTL,
            skin:
                localStorage.getItem('vuexy-skin') || $themeConfig.layout.skin,
            routerTransition: $themeConfig.layout.routerTransition,
            type: $themeConfig.layout.type,
            contentWidth: $themeConfig.layout.contentWidth,
            menu: {
                hidden: $themeConfig.layout.menu.hidden,
            },
            navbar: {
                type: $themeConfig.layout.navbar.type,
                backgroundColor: $themeConfig.layout.navbar.backgroundColor,
            },
            footer: {
                type: $themeConfig.layout.footer.type,
            },
            lang: '',
            currentUser: '',
            uuidNotification: '',
            refreshNotification: false,
            openNotifications: '',
        },
    },
    getters: {
        currentUser: state => state.layout.currentUser,
        uuidNotification: state => state.layout.uuidNotification,
        refreshNotification: state => state.layout.refreshNotification,
        openNotifications: state => state.layout.openNotifications,
    },
    mutations: {
        TOGGLE_RTL(state) {
            state.layout.isRTL = !state.layout.isRTL;
            document.documentElement.setAttribute(
                'dir',
                state.layout.isRTL ? 'rtl' : 'ltr'
            );
        },
        ADD_USER(state, payload) {
            state.layout.currentUser = payload;
        },
        ADD_UUID_NOTIFICATION(state, payload) {
            state.layout.uuidNotification = payload;
        },
        AddNotificationStatus(state, payload) {
            state.layout.refreshNotification = payload;
        },
        AddNotificationsValue(state, payload) {
            state.layout.openNotifications = payload;
        },
        CHANGE_LANGUAGE(state, lang) {
            state.layout.lang = lang;
        },
        UPDATE_SKIN(state, skin) {
            state.layout.skin = skin;

            // Update value in localStorage
            localStorage.setItem('vuexy-skin', skin);

            // Update DOM for dark-layout
            if (skin === 'dark') document.body.classList.add('dark-layout');
            else if (document.body.className.match('dark-layout'))
                document.body.classList.remove('dark-layout');
        },
        UPDATE_ROUTER_TRANSITION(state, val) {
            state.layout.routerTransition = val;
        },
        UPDATE_LAYOUT_TYPE(state, val) {
            state.layout.type = val;
        },
        UPDATE_CONTENT_WIDTH(state, val) {
            state.layout.contentWidth = val;
        },
        UPDATE_NAV_MENU_HIDDEN(state, val) {
            state.layout.menu.hidden = val;
        },
        UPDATE_NAVBAR_CONFIG(state, obj) {
            Object.assign(state.layout.navbar, obj);
        },
        UPDATE_FOOTER_CONFIG(state, obj) {
            Object.assign(state.layout.footer, obj);
        },
    },
    actions: {},
};
